// Components==============
import UnreadCount from 'components/UI/Communication/UnreadCount/UnreadCount';
import { useUnreadCount } from 'hooks/useUnreadCount';
import React, { useContext } from 'react';
import { ProjectCommunicationContext } from '../../Communication';
import './ProcessChats.module.scss';
// =========================

export default function ProcesChats() {
  const {
    channels,
    notifications,
    activeChannel,
    handleChannelChange,
  } = useContext(ProjectCommunicationContext);

  const getUnreadCount = useUnreadCount(notifications);

  return (
    <div styleName="activities">
      {channels?.map((channel, index) => (
        <div key={index} styleName="phase">
          <button
            onClick={() => handleChannelChange(channel)}
            styleName={`${channel?.id === activeChannel?.id ? 'active' : ''}`}
            type="button"
          >
            {!!channel.activities?.length && (
              <div
                styleName="vertical-line"
                style={{
                  height: channel?.activities?.length
                    ? 31 + (channel?.activities?.length - 1) * 43
                    : 0,
                }}
              />
            )}
            <img src={channel?.image} alt={channel?.name} />
            <p>{channel?.name}</p>
            {!!getUnreadCount(channel) && (
              <UnreadCount count={getUnreadCount(channel)} />
            )}
          </button>
          {channel?.activities?.map((activity, i) => (
            <button
              key={i}
              onClick={() => handleChannelChange(activity)}
              styleName={`${
                activity?.id === activeChannel?.id
                  ? 'activity active'
                  : 'activity'
              }`}
              type="button"
            >
              <div styleName="line" />
              <img src={activity?.image} alt={activity?.name} />
              <p>{activity?.name}</p>
              {!!getUnreadCount(activity) && (
                <UnreadCount count={getUnreadCount(activity)} />
              )}
            </button>
          ))}
        </div>
      ))}
    </div>
  );
}
